/* eslint-disable indent */
/* eslint-disable one-var */
/* eslint-disable no-use-before-define */
/* eslint-disable new-cap */
import axios from 'axios';
import { ElNotification } from 'element-plus';
import { removeUser } from '@/utils/auth';
import router from '../router';
import store from '@/store';


// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 120000 // 请求超时时间
});
// request拦截器

service.interceptors.request.use(
  config => {
    let token = null;

    if (store && store.getters && store.getters.token) {
      token = store.getters.token;
    }
    config.headers['Authorization'] = token;

    if (config.method === 'POST' || config.method === 'post') {
      config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    /**移除分页查询结果集中加入的queryData.list  */
    if (config.data && config.data.current && config.data.list) {
      delete config.data['list'];
    }

    // 时间戳 解决ie下缓存问题
    config.params = {
      _t: Date.parse(new Date()) / 1000,
      ...config.params
    };
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
// response 拦截器
service.interceptors.response.use(response => {
  const res = response.data;

  if (response.request.responseType === 'blob') {
    return response.data;
  } else if (res.success) {
    // if (res.code === 200) {
    //   ElNotification({ message: res.msg, type: 'success', duration: 500 });
    // }
    return response.data;
  } else if (res.success === false) {
    if (res.code === 2000) {
      ElNotification({ message: res.msg ? res.msg : '系统警告', type: 'warning', duration: 2000 });
    } else {
      ElNotification({ message: res.msg ? res.msg : '系统错误', type: 'error', duration: 2000 });
    }
    return response.data;
  }
},
  error => {
    if (!error.response || !error.response.status) {
      ElNotification.error({ title: '系统异常', message: '请联系管理员', duration: 2000 });
      return { msg: '系统异常,请联系管理员', code: '500', success: false };
    }
    const res = error.response.data;
    const code = error.response.status;

    if (code === 401) {
      removeUser();
      router.push('/login');
    } else {
      let msg = error.message;

      if (error.response.data && error.response.data.msg) {
        msg = error.response.data.msg;
      }
      ElNotification.error({ title: '温馨提示', message: msg, duration: 2000 });
    }
    return res;
  }
);
export function downFile (blob, fileName) {
  // 非IE下载
  if ('download' in document.createElement('a')) {
    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob); // 创建下载的链接
    link.download = fileName; // 下载后文件名
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click(); // 点击下载
    window.URL.revokeObjectURL(link.href); // 释放掉blob对象
    document.body.removeChild(link); // 下载完成移除元素
  } else {
    // IE10+下载
    window.navigator.msSaveBlob(blob, fileName);
  }
}
export default service;
